import HTTP from '../common/http-common';
const END_POINT = '/job';

const listJobInvoice = (branchCode) => HTTP.get(END_POINT + "/list-invoice/" + branchCode);

const listBpeInvoice = (id) => HTTP.get(END_POINT + "/get-invoice/" + id);
const listBpeService = (id) => HTTP.get(END_POINT + "/get-bpe-service/" + id);

const saveJobInvoice = (data) => HTTP.post(END_POINT + "/save-invoice" , data);

const existInvoiceNo = (branchCode, invoiceNo) => HTTP.get(END_POINT + "/existInvoiceNo", {
    params: {
        branchCode: branchCode,
        invoiceNo: invoiceNo
    }
});

export {
    listJobInvoice,
    saveJobInvoice,
    listBpeService,
    listBpeInvoice,
    existInvoiceNo
}